<template>
  <div>
    <v-form @submit.prevent="submit" ref="form">
      <v-select
        v-model="form.companyId"
        label="회사"
        :items="companyItems"
        outlined
        :loading="loading"
      ></v-select>

      <v-text-field
        v-model="form.value"
        label="태그명"
        outlined
        :rules="[required]"
      ></v-text-field>

      <v-btn type="submit" color="primary">{{ submitText }}</v-btn>
    </v-form>
  </div>
</template>

<script>
import { getCompanies, getTag, addTag, editTag } from '@/api'

export default {
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: null,
      companies: [],
      loading: false,
      form: {
        companyId: null,
        value: ''
      }
    }
  },
  computed: {
    submitText () {
      return this.edit ? '편집' : '등록'
    },
    companyItems () {
      return this.companies.map(company => {
        return {
          value: company.id,
          text: company.name
        }
      })
    },
    isAdmin () {
      return this.$store.getters['user/isAdmin']
    }
  },
  created () {
    this.fetchAccessibleCompanies()
  },
  async beforeRouteEnter (to, from, next) {
    const id = to.params.id

    if (!id) return next()

    try {
      const tag = await getTag(id)

      next(vm => {
        vm.id = tag.id
        vm.form.companyId = tag.companyId
        vm.form.value = tag.value
      })
    } catch (err) {
      console.error(err)
      next()
    }
  },
  methods: {
    required (val) {
      return !!val || '필수 입력 사항입니다.'
    },
    async fetchAccessibleCompanies () {
      this.loading = true

      try {
        const { items: companies } = await getCompanies()

        this.companies = companies
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    async submit () {
      if (!this.$refs.form.validate()) return
      if (!this.isAdmin && !this.form.companyId) {
        alert('회사를 선택하세요.')
        return
      }
      if (!confirm('이대로 적용 하시겠습니까?')) return
      this.edit ? this.putTag() : this.postTag()
    },
    async postTag () {
      try {
        await addTag(this.form)
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }
    },
    async putTag () {
      try {
        await editTag(this.id, this.form)
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }
    }
  }
}
</script>
